export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./basement.vue?vue&type=template&id=33dd5252"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/basement/basement.vue?vue&type=template&id=33dd5252
// module id = 1Bmb
// module chunks = 0